// extracted by mini-css-extract-plugin
export default {"ContactPage":"Contact_ContactPage__eY2Ih","sectionHead":"Contact_sectionHead__CDY70"};